<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-4">
        <h5>ユーザー変更</h5>
      </div>
      <div class="col-4">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する
          <b-tooltip target="destroyBtn" variant="secondary" triggers="hover">
            アカウントを削除します。<br>
            運用を開始したアカウントは<br>削除ではなく<br>廃止日を設定してください。
          </b-tooltip>
        </button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <div class="form-group">
          <div class="row" style="height: 130px;">
            <div class="col-3">
              <label>イメージ</label>
            </div>
            <div class="col-2">
              <img class="card-img" src="/person-bounding-box.svg" v-show="!isBlobUrl">
              <div class="trim-circle" :style="{ backgroundImage: 'url(' + blobUrl + ')' }" v-show="isBlobUrl">
                <button class="btn btn-primary rounded-circle p-0 delete-btn" style="width:2rem;height:2rem;" v-on:click="deleteImage">×</button>
              </div>
            </div>
            <div class="col-1">
            </div>
            <div class="col-6">
              <form enctype="multipart/form-data" @submit.prevent="upload">
                <div class="row">
                  <input type="file" accept="image/jpeg" ref="file" name="profile" v-on:change="selectedFile" style="margin-top: 10px;"/>
                </div>
                <div class="row">
                  <button class="btn btn-info setting-button-margin btn-sm">イメージ設定</button>
                </div>
                <div class="row">
                  <div class="alert alert-danger alert-margin small" role="alert"  style="padding: 0.5rem 0.5rem" v-show="isUploadFile">
                    イメージ設定ボタンを押してください
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ID</label>
              </div>
              <div class="col-9">
                <input type="text" v-model="user.userCode" class="form-control" autocomplete="off" placeholder="ユーザーID（必須）" disabled>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-4">
                <input type="text" maxlength="30" v-model="user.familyName" class="form-control" autocomplete="off" placeholder="姓（必須）" required :disabled="isFederation">
              </div>
              <div class="col-5">
                <input type="text" maxlength="30" v-model="user.givenName" class="form-control" autocomplete="off" placeholder="名（必須）" required :disabled="isFederation">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ふりがな</label>
              </div>
              <div class="col-4">
                <input type="text" maxlength="60" v-model="user.familyKana" class="form-control" autocomplete="off" placeholder="せい（必須）" required>
              </div>
              <div class="col-5">
                <input type="text" maxlength="60" v-model="user.givenKana" class="form-control" autocomplete="off" placeholder="めい（必須）" required>
              </div>
            </div>  
          </div>
          <div class="form-group" v-show="!isFederation">
            <div class="row">
              <div class="col-3">
                <label>パスワード</label>
              </div>
              <div class="col-9">
                <button type="button" class="btn-sm btn-outline-primary" v-on:click="reissue">パスワードを再発行する</button>
              </div>
            </div>
          </div>
          <div class="form-group" v-if="isProfession">
            <div class="row">
              <div class="col-3">
                <label>職種</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.profession" required @change="professionChanged">
                  <option value=""></option>
                  <option value="1">医師</option>
                  <option value="8">麻酔科</option>
                  <option value="6">看護役職</option>
                  <option value="2">看護師</option>
                  <option value="5">看護補助</option>
                  <option value="4">薬剤師</option>
                  <option value="9">放射線技師</option>
                  <option value="10">臨床検査技師</option>
                  <option value="7">検査科</option>
                  <option value="11">保育士</option>
                  <option value="12">保育補助</option>
                  <option value="13">理学療法士</option>
                  <option value="14">管理栄養士</option>
                  <option value="15">社会福祉士</option>
                  <option value="16">救急救命士</option>                  
                  <option value="3">事務</option>
                  <option value="0">その他</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group" v-if="isProfessionText">
            <div class="row">
              <div class="col-3">
                <label>職種名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="user.professionText" class="form-control" autocomplete="off" placeholder="職種名称">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>所属 (組織)</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.organizationId" :disabled="isFederation">
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.displayName }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>肩書</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-model="user.description" class="form-control" autocomplete="off" placeholder="肩書" :disabled=isFederation>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="!isFederation">
            <div class="row">
              <div class="col-3">
                <label>管理サイト権限</label>
              </div>
              <div class="col-9">
                <input name="privilege" id="member1" type="radio" value="1" v-model="user.privilege" required>
                <label for="member1" class="radio_label">使用不可</label><br>
                <input name="privilege" id="member2" type="radio" value="2" v-model="user.privilege">
                <label for="member2" class="radio_label">管理者</label><br>
                <input name="privilege" id="member3" type="radio" value="3" v-model="user.privilege">
                <label for="member3" class="radio_label">参照のみ</label><br>
                <input name="privilege" id="member9" type="radio" value="9" v-model="user.privilege" v-if="isSuper">
                <label for="member9" class="radio_label" v-if="isSuper">システム管理権限</label>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>追加機能権限</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="user.roleId">
                  <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                    {{ role.roleName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="form-group" v-if="isMediApo">
            <div class="row">
              <div class="col-3">
                <label>メディ・アポ</label>
              </div>
              <div class="col-9">
                <input name="appointmentUser" id="mediappoOn" type="radio" value="1" v-model="user.appointmentUser" required>
                <label for="mediappoOn" class="radio_label">使用する</label><br>
                <input name="appointmentUser" id="mediappoOff" type="radio" value="0" v-model="user.appointmentUser">
                <label for="mediappoOff" class="radio_label">使用しない</label><br>
              </div>
            </div>
          </div> -->
          <div class="form-group" v-if="isSuper && this.$store.getters.hospital.isConference">
            <div class="row">
              <div class="col-3">
                <label>ビデオ通話カンファレンス</label>
              </div>
              <div class="col-9">
                <input name="isUseConference" id="conferenceOn" type="radio" value="1" v-model="user.isUseConference" required>
                <label for="conferenceOn" class="radio_label">使用する</label><br>
                <input name="isUseConference" id="conferenceOff" type="radio" value="0" v-model="user.isUseConference">
                <label for="conferenceOff" class="radio_label">使用しない</label><br>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>共通連絡先の対象から外す</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="user.isExcluded">
              </div>
              <div class="col-7">
              </div>
            </div>  
          </div>
          <!-- <div class="form-group" v-if="isMediApo">
            <div class="row">
              <div class="col-3">
                <label>メールアドレス</label>
              </div>
              <div class="col-9">
                <input type="email" maxlength="256" v-model="user.email" class="form-control" placeholder="メールアドレス">
              </div>
            </div>
          </div> -->
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>アカウント廃止日</label>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <input ref="focusInput" type="date" class="form-control" v-model="user.disableAt" min="1900-01-01" max="2100-12-31">
                </div>
              </div>
            </div>  
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      message: '',
      id: '',
      organizationOptions: [],
      roles:[],
      historyId: -1,
      privilege: 0,
      user: {
        hospitalId: '',
        userCode: '',
        userName: '',
        userKana: '',
        password: '',
        profession: '',
        professionText: '',
        organizationId: 0,
        description: '',
        privilege: '',
        roleId: '',
        isExcluded: false,
        disableAt: '',
        familyName: '',
        givenName: '',
        familyKana: '',
        givenKana: '',
        email: '',
        appointmentUser: '',
        isUseConference: '',
        imagePath: ''
      },
      blobUrl: '',
      uploadFile: null
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.privilege) === 9
    },
    isMessage: function () {
      return this.message.length > 0
    },
    // isMediApo: function (){
    //   return this.serviceName === 'Nichibyo'
    // },
    isProfession: function (){
      return this.serviceName === 'Nichibyo'
    },
    isProfessionText: function (){
      if (this.serviceName === 'Nichibyo'){
        return this.user.profession === '0' || this.user.profession === 0
      } else {
        return true
      }
    },
    isFederation: function() {
      if(this.$store.getters.hospital.useFederation) {
        if(Number(this.privilege) === 9) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isBlobUrl: function() {
      return this.blobUrl.length > 0
    },
    isUploadFile: function() {
      return this.uploadFile !== null
    }
  },
  beforeMount(){
    this.id = this.$route.params.id
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.init()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.init()
        }
      }
    )
  },
  beforeDestroy: function() {
    if (this.isBlobUrl){
      URL.revokeObjectURL(this.blobUrl)
    }
  },
  methods: {
    modify() {
      if (this.user.familyName.startsWith("メンテナンスユーザー")) {
        this.message = "名称を変更してください"
        return
      }
      if (this.user.userCode.startsWith("maintenanceuser")) {
        this.message = "IDを変更してください"
        return
      }
      if (this.user.profession !== 0){
        if (this.user.profession !== "0") {
          this.user.professionText = null;
        }
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          this.setName()
          var accessToken = this.getAccessToken(this.$cognito,session)
          var userId = this.id;
          const userData = this.setUserData();
          axios.put("/api/user/" + userId, {
              user: userData
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              if (res.errorMessage.conferenceErrorMessage) {
                const errorMessage = `ユーザーの更新は完了しましたがカンファンレンスへのユーザー転記に失敗しました。失敗の理由を確認のうえユーザー変更画面より再度転記を試みてください。【失敗の理由】${res.errorMessage.conferenceErrorMessage}`;
                this.message = errorMessage;
              } else {
                this.message = res.errorMessage;
              }
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
    },
    reissue() {
      var id = this.id;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/reissue/'+id))
    },
    destroy() {
      if(confirm('この操作は取り消せませんがよろしいですか?')){
        //OK
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var userId = this.id;
          //API
          axios.delete("/api/user/" + userId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage == 'message exist') {
              //メッセージがあればダイアログ
              alert('このアカウントは運用中です。\nアカウント廃止日を入力して更新してください。');
              //OKで下部スクロール&フォーカス
              this.$refs.focusInput.focus()
            } else if(res.errorMessage) {
              if (res.errorMessage.conferenceErrorMessage) {
                const errorMessage = `ユーザーの削除は完了しましたがカンファンレンスへのユーザー転記に失敗しました。失敗の理由を確認してください。【失敗の理由】${res.errorMessage.conferenceErrorMessage}`;
                this.message = errorMessage;
              } else {
                this.message = res.errorMessage;
              }
            } else {
              //errorMessageがなければ削除成功
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    init() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          this.getCurrent(session).then(() =>{
            return this.getRole(session)
          }).then(() => {
            this.getOrganization(session)
          })
          var privilege = 0
          if(this.$cognito.isUseCognito){
            var idToken = session.getIdToken()
            privilege = idToken.payload['custom:privilege']
            if( privilege!== undefined) this.privilege = privilege
          } else {
            this.privilege = session.privilege
          }
        } else {
          //this.$router.replace('/login') 
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    getUser(session) {
      var accessToken = this.getAccessToken(this.$cognito,session)
      var userId = this.id;
      axios.get("/api/user/" + userId, {
          headers: this.headers(accessToken)
      }).then(response => {
        this.user = {
          userCode: response.data.data.userCode,
          userName: response.data.data.userName,
          userKana: response.data.data.userKana,
          profession: response.data.data.professionValue,
          professionText: response.data.data.professionText,
          organizationId: response.data.data.organizationId,
          description: response.data.data.description,
          privilege: response.data.data.privilege,
          roleId: response.data.data.roleId,
          isExcluded: response.data.data.isExcluded,
          disableAt: response.data.data.disableAt,
          familyName: response.data.data.familyName,
          givenName: response.data.data.givenName,
          familyKana: response.data.data.familyKana,
          givenKana: response.data.data.givenKana,
          email: response.data.data.email,
          appointmentUser: response.data.data.appointmentUser,
          isUseConference: response.data.data.isUseConference,
          imagePath: response.data.data.imagePath
        }
        this.getProfileImage(session)
      }).catch(err => {
        this.message = err.message
      })
    },
    getOrganization(session) {
      var accessToken = this.getAccessToken(this.$cognito,session)
      var hospitalId = this.$store.getters.hospital.id
      axios.post("/api/organization/management/belonglist",{
        hospitalId: hospitalId,
        historyId: this.historyId
      }, {
        headers: this.headers(accessToken)
      }).then(response => {
        this.organizationOptions = response.data.data.organizations
        this.getUser(session)
      }).catch(err => {
        throw err
      })
    },
    getCurrent(session) {
      if(this.$store.getters.organization){
        this.historyId = this.$store.getters.organization.historyId
        return Promise.resolve();
      } else {
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        return axios.get("/api/organization/management/current/" + hospitalId, {
          headers: this.headers(accessToken)
        }).then(response => {
          var data = response.data.data
          if(data){
            var organization = data.organization
            this.$store.commit('organization',{
                startAt: organization.startAt,
                historyId: organization.historyId
            })
            this.historyId = organization.historyId
          }
          return Promise.resolve();
        }).catch(err => {
          return Promise.resolve(err);
        })
      }
    },
    getRole(session){
      var accessToken = this.getAccessToken(this.$cognito,session)
      var hospitalId = this.$store.getters.hospital.id
      axios.get("/api/role/list/" + hospitalId,{
        headers: this.headers(accessToken)
      }).then(response => {
        this.roles = response.data.data.roles;
        this.roles.unshift({ id: null, roleName: null})
        return Promise.resolve();
      }).catch(err => {
        return Promise.resolve(err);
      })
    },
    setName() {
      this.user.userName = this.user.familyName + ' ' + this.user.givenName
      this.user.userKana = this.user.familyKana + ' ' + this.user.givenKana
    },
    setUserData() {
      const user = {
        hospitalId: this.user.hospitalId,
        userCode: this.user.userCode,
        userName: this.user.userName,
        userKana: this.user.userKana,
        password: this.user.password,
        profession: this.user.profession,
        professionText: this.user.professionText,
        organizationId: this.user.organizationId,
        description: this.user.description,
        privilege: this.user.privilege,
        roleId: this.user.roleId,
        isExcluded: this.user.isExcluded,
        disableAt: this.user.disableAt,
        familyName: this.user.familyName,
        givenName: this.user.givenName,
        familyKana: this.user.familyKana,
        givenKana: this.user.givenKana,
        email: this.user.email,
        appointmentUser: this.user.appointmentUser,
        isUseConference: this.user.isUseConference === 1 || this.user.isUseConference === "1",
        imagePath: this.user.imagePath
      }
      return user;
    },
    professionChanged() {
      this.user.professionText = null;
    },
    getProfileImage(session) {// get profile image
      const imagePath = this.user.imagePath
      if(!imagePath) {return}
      var accessToken = this.getAccessToken(this.$cognito,session)
      axios.get(imagePath, {
        headers: this.headers(accessToken),
        responseType: "blob"
      }).then(response => {
          var res = response.data;
          if(res.errorMessage) {
            this.message = res.errorMessage
          } else {
            this.blobUrl = URL.createObjectURL(response.data)
          }
      }).catch(err => {
        this.message = err.message
      })
    },
    selectedFile(event){
      let files = event.target.files
      this.uploadFile = files[0]
    },
    reset() {
      var input = this.$refs.file
      input.value = ''
      this.uploadFile = null
    },
    upload(){
      if (this.uploadFile === null){
        alert('ファイルが指定されていません。')
        return
      }
      var blob = new Blob([this.uploadFile], {type: 'application/octet-stream'})
      var userId = this.id;
      var hospitalId = this.$store.getters.hospital.id
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        axios.post("/api/user/management/profile/" + hospitalId + "/" + userId, blob,{
              headers: this.headersUploadStream(accessToken)
        }).then(response => {
          if(response !== undefined && response['errorMessage']) {
            this.message = response['errorMessage']
          } else {
            alert('イメージを設定しました。')
            this.user.imagePath = response.data.data.imagePath
            this.getProfileImage(session)
            this.reset()
          }
        })
      }}).catch((err) => {
        this.message = err.message
      })
    },
    deleteImage() {
      if(confirm('指定しているイメージを削除しますか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var userId = this.id;
          axios.delete("/api/user/management/profile/deleteImage/" + userId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              this.user.imagePath = ''
              URL.revokeObjectURL(this.blobUrl)
              this.blobUrl = ''
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.card-img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 2px #007bff solid;
}
.trim-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 2px #007bff solid;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.setting-button-margin{
  margin-top: 0.5rem;
}
.delete-btn {
  position: absolute;
  top: 70%;
  left: 105px;
}
</style>